import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source"]

  async copy(event) {
    await navigator.clipboard.writeText(this.sourceTarget.value)
    const original = event.currentTarget.textContent
    event.currentTarget.textContent = "Copied"
    setTimeout(() => event.currentTarget.textContent = original, 1500)
  }
}
